import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Store from './store';
import { App } from './containers';
import {
  RootRouteComponentWithSubRoutes,
  RoutesData,
} from './routes/routeWrapper';
import './config/firebase.ts';

import './assets/sass/main.scss';
import { publicRoutes, organizationRoutes } from './routes/routeConfigs';
import 'react-toastify/dist/ReactToastify.css';
const Routes: RoutesData[] = [...publicRoutes, ...organizationRoutes];

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <Provider store={Store}>
    <Router>
      <App>
        <RootRouteComponentWithSubRoutes routes={Routes} />
      </App>
    </Router>
  </Provider>
);
